import { Grid } from "@mui/material";
import dayjs from "dayjs";
import DatePickerControl from "./DatePickerControl";

type DateRangePickerControlProps = {
  name: string;
  disabled?: boolean;
  variant?: "outlined";
  hint?: string;
};

const rangeValidationMessage = 'Дата "От" не может быть позже даты "До"';

const isDateRangeValid = (from: string | undefined, to: string | undefined) => {
  if (!from || !to) return true;
  if (dayjs(from).isAfter(dayjs(to))) return rangeValidationMessage;
  return true;
};

const DateRangePickerControl = ({ name, disabled, variant, hint }: DateRangePickerControlProps) => {
  return (
    <Grid
      container
      spacing={1}>
      <Grid
        item
        xs={12}
        sm={6}>
        <DatePickerControl
          name={`${name}.from`}
          label='От'
          disabled={disabled}
          variant={variant}
          hint={hint}
          minDate={new Date()}
          rules={{
            validate: (fromValue: string, formValues: Record<string, { to?: string }>) => {
              const toValue = formValues[name]?.to;
              return isDateRangeValid(fromValue, toValue);
            },
          }}
          validateIfIsTouched
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}>
        <DatePickerControl
          name={`${name}.to`}
          label='До'
          disabled={disabled}
          variant={variant}
          hint={hint}
          minDate={new Date()}
          rules={{
            validate: (toValue: string, formValues: Record<string, { from?: string }>) => {
              const fromValue = formValues[name]?.from;
              return isDateRangeValid(fromValue, toValue);
            },
          }}
          validateIfIsTouched
        />
      </Grid>
    </Grid>
  );
};

export default DateRangePickerControl;
